import {append, isNotNil} from 'ramda';

import {ListVehicleFinancingTemplateResponseBody} from '@dms/api/sales';
import {VehicleFinancingType} from '@dms/api/vehicle';
import {getVehicleFinancingTemplateStatus} from '@dms/features/vehicle-financing-template';

import {getTemplateStatusLabel} from './getTemplateStatusLabel';

const isOfferedTemplate = (
  template: ListVehicleFinancingTemplateResponseBody,
  activeType: VehicleFinancingType
) => template.type === activeType && getVehicleFinancingTemplateStatus(template) === 'ACTIVE';

const toTemplateOption = (template: ListVehicleFinancingTemplateResponseBody) => {
  const status = getVehicleFinancingTemplateStatus(template);

  return {
    value: template.id,
    label:
      status === 'ACTIVE' ? template.name : `${template.name} · ${getTemplateStatusLabel(status)}`,
  };
};

/**
 * The templates the panel offers for the active financing type: every active template of that
 * type, followed by the selected template when it is no longer active. Leaving the stale selection
 * out would give the `Choice` a value none of its options carry, which renders as an empty field.
 */
export function buildFinancingTemplateOptions(
  templates: ListVehicleFinancingTemplateResponseBody[],
  activeType: VehicleFinancingType,
  selectedTemplateId: string | null
) {
  const offeredTemplates = templates.filter((template) => isOfferedTemplate(template, activeType));
  // Being inactive is what makes the selection stale, so it can never be an offered template too.
  const staleSelection = templates.find(
    (template) =>
      template.id === selectedTemplateId && getVehicleFinancingTemplateStatus(template) !== 'ACTIVE'
  );

  const listedTemplates = isNotNil(staleSelection)
    ? append(staleSelection, offeredTemplates)
    : offeredTemplates;

  return listedTemplates.map(toTemplateOption);
}
